import { useState } from 'react'
import { DrawType, Mode } from '../types/mapStateProps'

export const useMapDrawing = (width: number, height: number, mode: Mode = 'view', drawType: DrawType = 'shape') => {
  const [points, setPoints] = useState<number[]>([])
  const [point, setPoint] = useState<[number, number] | null>(null)

  const handleClick = (e: any) => {
    if (mode !== 'draw') return

    const pos = e.target.getStage().getPointerPosition()
    const x = pos.x / width
    const y = pos.y / height

    // 🟢 DOT MODE
    if (drawType === 'dot') {
      setPoint([x, y])
      return
    }

    // 🔷 SHAPE MODE (existing behavior)
    setPoints(prev => [...prev, x, y])
  }

  const convertToPairs = (points: number[]): [number, number][] => {
    const result: [number, number][] = []

    for (let i = 0; i < points.length; i += 2) {
      result.push([points[i], points[i + 1]])
    }

    return result
  }

  const finishShapeDrawing = () => {
    if (points.length < 6) return null
    return convertToPairs(points)
  }

  const finishDotDrawing = () => {
    if (!point) return null

    return point
  }

  const undo = () => {
    if (drawType === 'dot') {
      setPoint(null)
      return
    }

    setPoints(prev => {
      if (prev.length < 2) return prev
      return prev.slice(0, -2)
    })
  }

  const resetPoints = () => {
    setPoints([])
    setPoint(null)
  }

  return {
    // polygon
    points,
    setPoints,

    // point
    point,
    setPoint,

    // actions
    handleClick,
    undo,
    resetPoints,
    finishShapeDrawing,
    finishDotDrawing,
  }
}
